/** @format */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Master from '../Layouts/Master';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';

const CreateTicket = () => {
  const navigate = useNavigate();
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!subject.trim() || !body.trim()) {
      return error('موضوع و متن تیکت الزامی است');
    }

    setLoading(true);
    await useApi.post(
      '/panel/tickets',
      { subject: subject.trim(), body: body.trim() },
      (res) => {
        success(res.data?.message || 'تیکت ثبت شد');
        const id = res.data?.data?.id;
        navigate(id ? `/panel/tickets/${id}` : '/panel/tickets');
      },
      (err) => {
        setLoading(false);
        error(err?.data?.message || 'ثبت تیکت با خطا مواجه شد');
      }
    );
  };

  return (
    <Master>
      <div className="d-flex flex-row align-items-center border-bottom pb-3 my-3">
        <i className="fad fa-life-ring f-20 text-secondary mx-2"></i>
        <h1 className="text-secondary f-14 font-weight-bold mb-0">ثبت تیکت جدید</h1>
      </div>

      <form onSubmit={handleSubmit} className="card border shadow-sm p-4">
        <div className="form-group mb-3">
          <label className="f-13">موضوع</label>
          <input
            type="text"
            className="form-control"
            maxLength={190}
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
        <div className="form-group mb-3">
          <label className="f-13">متن پیام</label>
          <textarea
            className="form-control"
            rows={8}
            maxLength={5000}
            value={body}
            onChange={(e) => setBody(e.target.value)}
          />
        </div>
        <div className="d-flex flex-row">
          <button type="submit" className="btn btn-info" disabled={loading}>
            {loading ? 'در حال ارسال...' : 'ارسال تیکت'}
          </button>
          <button
            type="button"
            className="btn btn-light mx-2"
            onClick={() => navigate('/panel/tickets')}
          >
            انصراف
          </button>
        </div>
      </form>
    </Master>
  );
};

export default CreateTicket;
